"use strict";

module.exports = function checkAny() {
	return true;
};